import i18nConfig from '@/config/i18n'
import { LanguageCountryCodes } from '@/enums/general'
import { stripLanguageRegex } from '@/utils/general'
import { useRouter } from 'nuxt/app'

export default defineNuxtPlugin(() => {
  const router = useRouter()

  // Local state for HTML lang attribute
  const htmlLang = ref(i18nConfig.defaultLocale)

  // Local state for hreflang link tags
  const hrefLangLinks = ref<any[]>([])

  const setHtmlLangAttribute = (to: any) => {
    const languageParam = to.fullPath.match(stripLanguageRegex)
    htmlLang.value = languageParam ? `${languageParam[0][1]}${languageParam[0][2]}` : i18nConfig.defaultLocale
  }

  const config = useRuntimeConfig()
  const BASE_URL = config?.public.BASE_URL

  const generateHrefLangTags = (pathWithSlash: string) => {
    return Object.values(LanguageCountryCodes).map((code) => {
      const urlCode = code.replace('_', '-').toLowerCase() // go from nl_NL to nl-nl
      return {
        rel: 'alternate',
        hid: `lang_${code}`,
        hreflang: urlCode,
        href: `${BASE_URL}/${urlCode}${pathWithSlash}`
      }
    })
  }

  const setCurrentHrefLangTags = (to: any) => {
    const pathWithSlashWithoutLanguageCode = to.fullPath.replace(stripLanguageRegex, '')
    const normalizedPath = pathWithSlashWithoutLanguageCode.startsWith('/') ? pathWithSlashWithoutLanguageCode : `/${pathWithSlashWithoutLanguageCode}`
    const hrefLangTags = [
      ...generateHrefLangTags(normalizedPath),
      {
        rel: 'alternate',
        hid: 'lang_default',
        hreflang: 'x-default',
        href: `${BASE_URL}/en-gb${normalizedPath}`
      }
    ]

    hrefLangLinks.value = hrefLangTags
  }

  // Set up router afterEach hook to manage hreflang tags
  router.afterEach((to) => {
    setHtmlLangAttribute(to)
    setCurrentHrefLangTags(to)
  })

  // Set initial values for current route
  if (import.meta.client) {
    const currentRoute = router.currentRoute.value
    setHtmlLangAttribute(currentRoute)
    setCurrentHrefLangTags(currentRoute)
  }

  // Expose state via provide
  return {
    provide: {
      htmlLang,
      hrefLangLinks
    }
  }
})
